import dayjs from 'dayjs';
import genreList from '@/config/copyright/genreList'
import { sourceTypeFilter } from '@/config/copyright/sourceType'
import { dataBusinessTypeFilter } from '@/config/copyright/dataBusinessType'
import { sourceFileUploadTypeFilter } from '@/config/copyright/sourceFileUploadType'
const timeFormat = (value, format = "YYYY-MM-DD") => {
    if (value === undefined) {
        return '-'
    }
    let time = dayjs(value).format(format)
    return time
}

const statisticsFormat = (value) => {
    if (!value) {
        return 0
    }
    return value.toString().replace(/(\d{1,3})(?=(\d{3})+$)/g, '$1,')
}

const mapFilter = (value, list) => {
    if (value === undefined) {
        return '-'
    }
    let obj = list.find(item => item.value === value)
    return obj ? obj.name : '-'
}
// 类型
const typeTextFilter = (value, categoryNames) => {
    if (value !== null || categoryNames !== undefined) {
        let obj = genreList.find(item => item.value === value)
        let newCategoryNames = categoryNames || ''
        let text = obj ? obj.name : ''
        if (newCategoryNames) {
            text = `${text}-${newCategoryNames}`
        }
        return text
    } else {
        return ''
    }
}

//文件类型数字转文字
const fileTypeToText=(typeNum)=>{
  switch (typeNum) {
    case 101:
      return '文字作品'
      break
    case 102:
      return '音乐作品'
      break
    case 103:
      return '音像'
      break
    case 104:
      return '美术作品'
      break
    case 105:
      return '设计作品'
      break
    case 106:
      return '雕塑'
      break
    case 107:
      return '工程图纸'
      break
    case 108:
      return '软件项目'
      break
    case 109:
      return '商业秘密'
      break
    case 110:
      return '摄影作品'
      break
    case 111:
      return '产品设计图'
      break
    case 112:
      return '视听作品'
      break
    case 113:
      return '汇编作品'
      break
    case 114:
      return '产品原型图'
      break
    case 115:
      return '产品流程图'
      break
    case 116:
      return 'UI设计图'
      break
    case 117:
      return '需求说明文档'
      break
    case 118:
      return '测试用例'
      break
    case 119:
      return '工业项目'
      break
    case 120:
      return '硬件项目'
      break
    case 121:
      return '科研成果'
      break
    case 122:
      return '数据资产'
      break
    case 123:
      return '商标设计'
      break
    case 124:
      return '专利文档'
      break
    case 125:
      return '讲义课件'
      break
    case 132:
      return '口述作品'
      break
    case 133:
      return '戏剧曲艺作品'
      break
    case 134:
      return '舞蹈杂技作品'
      break
    case 135:
      return '建筑作品'
      break
    case 136:
      return '图形作品'
      break
    case 137:
      return '模型作品'
      break

    case 999:
      return '其它'
      break
  }
}

export default {
    timeFormat,
    statisticsFormat,
    mapFilter,
    typeTextFilter,
    fileTypeToText,
    sourceTypeFilter,
    dataBusinessTypeFilter,
    sourceFileUploadTypeFilter,
}


